import {
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorMode,
} from '@chakra-ui/react'
import React from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { gameState, modalState, userState } from './store'
import { numberWithCommas } from './utils'

export default function Players() {
  const { colorMode } = useColorMode()
  const game = useRecoilValue(gameState)
  const user = useRecoilValue(userState)
  const setModal = useSetRecoilState(modalState)

  return (
    <Table variant="striped" size="sm">
      <Thead>
        <Tr>
          <Th>user</Th>
          <Th>@</Th>
          <Th>bet</Th>
          <Th>profit</Th>
        </Tr>
      </Thead>
      <Tbody>
        {game.bets.map(bet => {
          // * bet.multiplier = cashed out
          let color
          if (bet.multiplier) {
            color = 'green.500'
          } else if (game.state === 'CRASHED') {
            color = 'red.500'
          }

          let profit
          if (bet.multiplier) {
            profit = numberWithCommas(
              Math.floor(bet.amount * (bet.multiplier / 100) - bet.amount)
            )
          } else if (game.state === 'CRASHED') {
            profit = numberWithCommas(-bet.amount)
          } else {
            profit = '-'
          }

          // Highlight your name
          const rowBgColor =
            bet.username === user.username
              ? colorMode === 'light'
                ? '#FBD38D'
                : '#4f402d'
              : null

          return (
            <Tr color={color} key={bet.id}>
              <Td style={{ backgroundColor: rowBgColor }}>
                <Text
                  as="span"
                  cursor="pointer"
                  onClick={() => setModal(`user ${bet.username}`)}
                >
                  {bet.username}
                </Text>
              </Td>
              <Td style={{ backgroundColor: rowBgColor }}>
                {bet.multiplier ? `${bet.multiplier / 100}x` : '-'}
              </Td>
              <Td style={{ backgroundColor: rowBgColor }}>
                {numberWithCommas(bet.amount)}
              </Td>
              <Td style={{ backgroundColor: rowBgColor }}>{profit}</Td>
            </Tr>
          )
        })}
      </Tbody>
    </Table>
  )
}
